var exports = {
  "kL": "container__-reUmk",
  "oD": "headingArea__S6rRhX",
  "Y0": "headingWithSkipLink__q0NEvV",
  "ZC": "skipLinkContainer__lT79kV",
  "u$": "skipLink__c7C7IV",
  "R_": "heading__B7lftx",
  "xu": "controlsRow__XfPhtA",
};

module.exports = exports;
